import { Component, inject, OnInit } from '@angular/core';
import { RoleCodes } from 'core/enums/role';
import { DhofarSharedSidebarComponent } from 'dhofar-shared-pkg';
import { AuthenticationService } from 'core/services/auth/authentication.service';
import { AuthorizationService } from 'core/services/auth/authorization.service';
import { ConfigService } from 'core/services';
import { ThemeService } from 'core/services/theme/theme.service';

interface SidebarDefault {
  label: string;
  routerLinkName: string;
  icon?: string;
  svgIcon?: string;
  permissions?: string[];
}
interface Sidebar extends SidebarDefault {
  children?: SidebarDefault[];
}

@Component({
  selector: 'app-sidebar',
  imports: [DhofarSharedSidebarComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  user: any = {
    name: '',
    nameAr: '',
    nameEn: '',
    role: 'Admin',
    avatar: 'assets/images/logo/DhofarDarkLogo.png'
  };
  roleCode = '';

  authService = inject(AuthenticationService);
  authorizationService = inject(AuthorizationService);
  configService = inject(ConfigService);
  themeService = inject(ThemeService);

  sidebarItems: Sidebar[] = [
    {
      label: 'PAGES.DASHBOARD.TITLE',
      icon: 'pi pi-home',
      routerLinkName: '/dashboard',
      permissions: [RoleCodes.Administrator]
    },
    {
      label: 'PAGES.TESTS.TITLE',
      icon: 'pi pi-file',
      routerLinkName: '/tests',
      permissions: [RoleCodes.Administrator]
    },
    {
      label: 'PAGES.CATEGORIES.TITLE',
      icon: 'pi pi-folder',
      routerLinkName: '/categories',
      permissions: [RoleCodes.Administrator]
    },
    {
      label: 'PAGES.PAGES.TITLE',
      icon: 'pi pi-book',
      routerLinkName: '/pages',
      permissions: [RoleCodes.Administrator]
    },
    {
      label: 'PAGES.SECTIONS.TITLE',
      icon: 'pi pi-th-large',
      routerLinkName: '/sections',
      permissions: [RoleCodes.Administrator]
    },
    {
      label: 'PAGES.NEWS_LETTER.TITLE',
      icon: 'pi pi-envelope',
      routerLinkName: '/news-letter',
      permissions: [RoleCodes.Administrator]
    },
    {
      label: 'PAGES.FAQS.TITLE',
      icon: 'pi pi-question-circle',
      routerLinkName: '/faqs',
      permissions: [RoleCodes.Administrator]
    },
    {
      label: 'PAGES.SETTINGS.TITLE',
      icon: 'pi pi-cog',
      routerLinkName: '/settings',
      permissions: [RoleCodes.Administrator],
      children: [
        {
          label: 'PAGES.SETTINGS.GENERAL.TITLE',
          icon: 'pi pi-sliders-h',
          routerLinkName: '/settings/general-settings',
          permissions: [RoleCodes.Administrator]
        },
        {
          label: 'PAGES.SETTINGS.CATEGORIES.TITLE',
          icon: 'pi pi-folder-plus',
          routerLinkName: '/settings/categories',
          permissions: [RoleCodes.Administrator]
        },
        {
          label: 'PAGES.LANGUAGES.TITLE',
          icon: 'pi pi-globe',
          routerLinkName: '/settings/languages',
          permissions: [RoleCodes.Administrator]
        }
      ]
    }
  ];

  constructor() {}

  ngOnInit(): void {
    // AUTHENTICATION DISABLED FOR TESTING - Set default values to show sidebar menu
    this.roleCode = RoleCodes.Administrator; // Set default role code so sidebar can display menu items
    this.user.name = 'Test User';
    this.user.nameEn = 'Test User';
    this.user.nameAr = 'مستخدم تجريبي';
    this.user.role = 'Admin';

    // Original code - disabled for testing
    // this.authService.authNavStatus$.subscribe(res => {
    //   if (res) {
    //     this.user.nameAr = this.authService.User?.profile.EmployeeAr;
    //     this.user.nameEn = this.authService.User?.profile.EmployeeEn;
    //     this.user.name = this.user.nameEn || this.user.nameAr || 'User Name';

    //     // Get role code from authorization service
    //     const roles = this.authorizationService.getRoles();
    //     if (roles && roles.length > 0) {
    //       this.roleCode = roles[0].roleCode;
    //     }
    //   }
    // });
  }

  async handleSignOut() {
    await this.authService.signout();
  }

  /**
   * Handle theme toggle from sidebar
   */
  handleThemeToggle() {
    this.themeService.toggleTheme();
  }
}
